import { React, useEffect, useState, useRef, useMemo, Fragment } from "react";
import Navbar from "../Components/Navbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Loading from "../Components/Loading";
import { setDivision } from "../Redux/Action/division";
import LoadingSpinner from "../Components/Loader/UploadLoader";

const Receipt = ({ cashPoToPass, hideNavBar }) => {
  const dispatch = useDispatch();
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL_REPORTS = process.env.REACT_APP_BASEURL_REPORTS;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const userState = useSelector((state) => state.changeTheState.user);
  const divisionState = useSelector((state) => state.changeDivision);
  const email = userState?.emailId;
  const [division, setdivsion] = useState(divisionState);
  const [date, setDate] = useState(new Date());
  const [receiptdata, setreceiptdata] = useState([]);
  const [listofpaymentmodes, setlistofpaymentmodes] = useState([]);
  const [selpaymentmode, setselpaymentmode] = useState("");
  const [newReceiptNo, setnewReceiptNo] = useState("");
  const [latestReceiptNo, setLatestReceiptNo] = useState("");
  const [pendingtopay, setpendingtopay] = useState(0);
  const location = useLocation();
  const invoiceno = location.state ? location.state.cashsaleno : "";
  const totalamount = location.state ? location.state.total : "";
  const totalvat = location.state ? location.state.vat : "";
  const totallevy = location.state ? location.state.levy : "";
  const [alreadypaidamt, setalreadypaidamt] = useState("");
  const [cashsaledata, setcashsaledata] = useState([]);
  const [cashsalepopup, setcashsalepopup] = useState(false);
  const [isloading, setisloading] = useState(true);
  const [narration, setnarration] = useState("");
  const [receivedamt, setreceivedamt] = useState("");
  const [changegiven, setchangegiven] = useState("");
  const [krapinNo, setKraPinNo] = useState("");
  const [search, setSearch] = useState("");
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );

  const [startdate, setstartdate] = useState(localStartOfMonth.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());
  const [historic, sethistoric] = useState([]);
  const [hinvoice, sethinvoice] = useState("");
  const [htotal, sethtotal] = useState("");
  const [historicreceipts, sethistoricreceipts] = useState(false);
  const [financialReceiptNo, setFinancialReceiptNo] = useState("");
  const [ShowTable, setShowTable] = useState(location.state ? true : false);
  const [htillno, sethtillno] = useState("");
  const [tillno, settillno] = useState("");
  const [hvat, sethvat] = useState("");
  const [hlevy, sethlevy] = useState("");
  const [charge, setCharge] = useState("");
  const [vatperc, setvatperc] = useState(location.state ? 16 : null);
  const [levyperc, setlevyperc] = useState(location.state ? 2 : null);
  const [firstReceiptNo, setFirstReceiptNo] = useState("");

  const [targetValue, setTargetValue] = useState("");

  const [userdivisionRights, setuserDivisionList] = useState([]);

  const [pdfData, setPdfData] = useState(null);
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
  const [hist, setHist] = useState(false);
  const [reportName, setReportName] = useState("");
  const [reportPath, setReportPath] = useState("");

  const [paymentDetails, setPaymentDetails] = useState([]);
  const [salesBills, setSalesBills] = useState([]);
  const [originalBills, setOriginalBills] = useState([]);
  const [searchSales, setSearchSales] = useState("");
  const [salStartdate, setSalStartDate] = useState("");
  const [salEndDate, setSalEndDate] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalBill, setTotalBill] = useState("");
  const [totalReceiveAmt, setTotalReceiveAmt] = useState("");
  const [selectPaymentList, setSelectPaymentList] = useState([]);
  const [histTableData, setHistTableData] = useState([]);
  const [recoverFromWaiter, setRecoverFromWaiter] = useState(false);
  const [mergeBills, setMergeBills] = useState(false);
  const [narrationForRecover, setNarrationForRecover] = useState("");
  const [company, setCompany] = useState({});
  const [PopUpReport, setPopUpReport] = useState(false);
  const [selWaiterEmail, setSelWaiterEmail] = useState(email);
  const [waiterList, setWaiterList] = useState([]);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [selReason, setSelReason] = useState("");
  const [showCancel, setShowCancel] = useState(false);

  const [createdBy, setCreatedBy] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [approved, setApproved] = useState(false);
  const [approvedBy, setApprovedBy] = useState("");
  const [approvedDate, setApprovedDate] = useState("");
  const [cancelled, setCancelled] = useState(false);
  const [cancelledBy, setCancelledBy] = useState("");
  const [cancelledDate, setCancelledDate] = useState("");

  useEffect(() => {
    axios
      .get(`${BASEURL}/getdivisionRights?OM_USER_ACCOUNT=${email}`)
      // .get(
      //   `${BASEURL_GLOBAL}/globalViewHandler?viewname=568&OM_USER_ACCOUNT=${email}`,
      //   {
      //     headers: {
      //       "auth-token": authToken,
      //       "session-token": sessiontoken,
      //     },
      //   }
      // )
      .then((response) => {
        setuserDivisionList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const customStyless = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: "200px",
      maxWidth: "200px",
      marginTop: "0px",
      minHeight: "initial",
      height: "30px",
      border: "1px solid",
      paddingBottom: "0px",
      paddingTop: "0px",
      marginLeft: "0px",
      backgroundColor: "white",
      color: "black",
      textTransform: "uppercase",
      "@media (max-width: 720px)": {
        minWidth: "181px",
      },
    }),
  };

  const filtHistoric = receiptdata.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const sDate = item.RECEIPTDATE;
    const eDate = item.RECEIPTDATE;

    if (searchData.length === 0 && !startdate && !enddate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["RECEIPTNO", "DIVISION", "RECEIPTAMOUNT"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const dateMatch =
      (!startdate || sDate >= startdate) && (!enddate || eDate <= enddate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    if (divisionState) {
      axios
        .get(
          `${BASEURL_GLOBAL}/globalViewHandler?viewname=555&DIVISION=${divisionState}`,
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        )
        .then((res) => {
          setWaiterList(res.data);
        })
        .catch((error) => {
          console.error("Error fetching 555:", error);
        });
    }
  }, [divisionState]);

  useEffect(() => {
    getCompanyDetails();
    getNewReceiptNo();
    getPaymentModeDetails();
    getAllReceiptsDetails();
    getCancelList();
  }, []);

  const getCompanyDetails = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => setCompany(res?.data[0]))
      .catch((err) => {
        setisloading(false);
        console.log("Error While fetching Driver List", err);
      });
  };

  const getCancelList = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1747`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCancelReasonList(res?.data);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error While fetching 1747", err);
      });
  };

  const getNewReceiptNo = () => {
    axios
      // .get(`${BASEURL}/getNewReceiptNo`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=636`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setnewReceiptNo(response.data[0].RECIEPTNO);
        setLatestReceiptNo(response.data[0].RECIEPTNO);
      })
      .catch((error) => {
        console.error("Error fetching New Receipt No:", error);
      });
  };

  const getPaymentModeDetails = () => {
    axios
      // .get(`${BASEURL}/getPaymentModes`, {
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1715&USEREMAIL=${email}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setlistofpaymentmodes(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Receipts Data:", error);
      });
  };

  const getAllReceiptsDetails = () => {
    axios
      // .get(`${BASEURL}/getAllReceiptsReceipt`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=649`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setreceiptdata(response.data);
        setFirstReceiptNo(response.data[0].RECEIPTNO);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Receipts Data:", error);
      });
  };

  useEffect(() => {
    if (invoiceno !== "" && invoiceno !== null && invoiceno !== undefined) {
      getAlreadyPaidAmount();
      getCashSaleHistoryDetails();
    }
  }, [invoiceno]);

  const getAlreadyPaidAmount = () => {
    axios
      .get(
        // `${BASEURL}/getAlreadyPaidAmount`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=637&CASHSALENO=${invoiceno}`,
        // {
        //   cashsaleno: invoiceno,
        // },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        setalreadypaidamt(response?.data[0]?.ALREADYPAIDAMT);
        if (response?.data[0]?.ALREADYPAIDAMT > 0) {
          setpendingtopay(
            htotal
              ? Number(htotal) - Number(response?.data[0]?.ALREADYPAIDAMT)
              : totalamount
                ? Number(totalamount) -
                  Number(response?.data[0]?.ALREADYPAIDAMT)
                : "",
          );
        } else {
          setpendingtopay(
            htotal ? Number(htotal) : totalamount ? Number(totalamount) : "",
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching Already Paid Amount Data:", error);
      });
  };

  const getCashSaleHistoryDetails = () => {
    axios
      .get(
        // `${BASEURL}/getCashSaleHistoryDetails`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=622&INVNO=${invoiceno}`,
        // {
        //   invoiceno: invoiceno,
        // },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setcashsaledata(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Cash Sale Data:", error);
      });
  };

  const fetchAllDetails = async (ReceiptNo) => {
    setSelectedRows([]);
    setShowTable(true);
    sethistoricreceipts(true);
    setPdfData(null);
    await axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=649&RECEIPTNO=${ReceiptNo}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setdivsion(response.data[0].DIVISION);
        setnewReceiptNo(response.data[0].RECEIPTNO);
        setDate(response.data[0].RECEIPTDATE);
        setTotalReceiveAmt(response.data[0].RECEIPTAMOUNT);
        setchangegiven(response.data[0].CHANGEGIVEN);
        setRecoverFromWaiter(response.data[0].RECOVEREDBYWAITED);
        setFinancialReceiptNo(response.data[0].FINANCIALRECEIPTNO);
        setCreatedDate(response.data[0].CREATEDTIME);
        setCreatedBy(response.data[0].CREATEDBY);
        setCancelled(response.data[0].CANCELLED);
        setCancelledBy(response.data[0].CANCELLEDBY);
        setCancelledDate(response.data[0].CANCELLEDDATE);

        axios
          .get(
            `${BASEURL_GLOBAL}/globalViewHandler?viewname=1713&RECEIPTNO=${response.data[0].RECEIPTNO}`,
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessiontoken,
              },
            },
          )
          .then((res) => {
            setHistTableData(res?.data);
          })
          .catch((error) => {
            console.error("Error fetching 1713:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching List Of Receipts:", error);
      });
  };

  const handleButtonClick = async (operation) => {
    try {
      // const latestReceiptNo = await getLatestReceiptNo();

      if (operation === "decrement" && newReceiptNo > firstReceiptNo) {
        setnewReceiptNo(newReceiptNo - 1);
        fetchAllDetails(newReceiptNo - 1);
      } else if (operation === "increment" && newReceiptNo < latestReceiptNo) {
        setnewReceiptNo(newReceiptNo + 1);
        fetchAllDetails(newReceiptNo + 1);
      } else if (operation === "first") {
        setnewReceiptNo(firstReceiptNo);
        fetchAllDetails(firstReceiptNo);
      } else if (operation === "latest") {
        setnewReceiptNo(latestReceiptNo - 1);
        fetchAllDetails(latestReceiptNo - 1);
      }
    } catch (error) {
      console.error("Error handling button click:", error);
    }
  };

  const getLatestReceiptNo = async () => {
    try {
      // const response = await axios.get(`${BASEURL}/getNewReceiptNo`, {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=636`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      return response.data[0].RECIEPTNO;
    } catch (error) {
      console.error("Error fetching New Receipt No:", error);
    }
  };

  const handleReceipts = (row) => {
    // setShowTable(true);
    setSelectedRows([]);
    sethistoricreceipts(true);
    setPdfData(null);
    setdivsion(row.DIVISION);
    setnewReceiptNo(row.RECEIPTNO);
    // sethinvoice(row.CASHSALENO);
    setDate(row.RECEIPTDATE);
    // sethtotal(row.RECEIPTAMOUNT);
    // setnarration(row.RECEIPTNARRATION);
    // setselpaymentmode(row.PAYMODE);
    // setUs(row.CREATEDBY);
    setTotalReceiveAmt(row.RECEIPTAMOUNT);
    setchangegiven(row.CHANGEGIVEN);
    setRecoverFromWaiter(row.RECOVEREDBYWAITED);
    setFinancialReceiptNo(row.FINANCIALRECEIPTNO);
    // setKraPinNo(row.KRAPIN);
    // setvatperc(16);
    // setlevyperc(2);
    // if (row.PAYMODE === "CREDIT") {
    // }
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1713&RECEIPTNO=${row.RECEIPTNO}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setHistTableData(response?.data);
      })
      .catch((error) => {
        console.error("Error fetching 1713:", error);
      });
  };

  async function SaveReceipts() {
        // ---------------------------------------------------------
  // At least one Payment Mode must have data
  // ---------------------------------------------------------
  const hasPaymentMode = selectPaymentList?.some((row) => {
    const payMode = (row?.payMode || "").trim();
    const amount = Number(row?.amount || 0);

    return payMode !== "" && amount > 0;
  });

  if (!hasPaymentMode) {
    alert("Please enter/select at least one Payment Mode with an amount.");
    return;
  }

    // Validate reference number for MPESA/CARD payments
    const invalidPayment = selectPaymentList?.find((row) => {
      const payMode = (row.payMode || "").toUpperCase().trim();

      return (
        (payMode === "MPESA" || payMode.includes("CREDIT CARD")) &&
        !row.refNo?.trim()
      );
    });

    if (invalidPayment) {
      alert(`Please enter the Reference Number for ${invalidPayment.payMode}.`);
      return;
    }

    if (recoverFromWaiter === true && !selWaiterEmail) {
      alert("Kindly supply Waiter Email");
      return;
    }

    if (recoverFromWaiter === true && !narrationForRecover) {
      alert("Kindly supply Narration");
      return;
    }

    try {
      setisloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=34`,
        {
          RECIEPTNO: Number(newReceiptNo),
          RECIEPTINVNO: selectedRows ? Number(selectedRows?.[0]?.BILLNO) : 0,
          RECIEPTDATE: moment(new Date())?.format("YYYY/MM/DD HH:mm:ss"),
          RECIEPTAMOUNT: totalBill ? Number(totalBill) : 0,
          RECIEPTNARRATION: narrationForRecover || "",
          RECIEPTPAYMODE: selectedRows?.[0]?.CASH
            ? "CASH"
            : selectedRows?.[0]?.MPESA
              ? "MPESA"
              : selectedRows?.[0]?.CREDITCARD
                ? "CREDIT"
                : "",
          RECIEPTPAYREFNO: "",
          RECIEPTPAYREFACCOUNT: "",
          RECIEPTCREATEDDATE: moment(new Date())?.format("YYYY/MM/DD HH:mm:ss"),
          RECIEPTCREATEDBY: userState.emailId.split("@")[0].toUpperCase(),
          RECIEPTDIVISION: division,
          RECIEPTMONEYGIVEN: totalReceiveAmt ? Number(totalReceiveAmt) : 0,
          RECIEPTCHANGEGIVEN: changegiven ? Number(changegiven) : 0,
          KRAPINNO: krapinNo,
          NEWEXISTING: historicreceipts === true ? "EXISTING" : "NEW",
          RECOVEREDFROMWAITER: recoverFromWaiter === true ? 1 : 0,
          WAITEREMAIL:
            recoverFromWaiter === true
              ? selWaiterEmail
                ? selWaiterEmail
                : ""
              : "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Headers saved successfully`);
        await savePayMode(response?.data?.message);
      } else {
        console.error(`Error while saving headers`);
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      setisloading(false);
      console.error(`Error while saving row headers`, error);
    }
  }

  async function savePayMode(rpNo) {
    try {
      const results = await Promise.allSettled(
        selectPaymentList.map((row) =>
          axios.post(
            `${BASEURL_GLOBAL}/globalSpHandler?spname=1711`,
            {
              RECIEPTNO: Number(rpNo),
              PAYMODE: row.payMode ? row.payMode : "",
              RECEIPTREFNUMBER: row.refNo ? row.refNo : "",
              ALLOCATEDAMOUNT: row.amount ? Number(row.amount) : 0,
            },
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessiontoken,
              },
            },
          ),
        ),
      );

      const failed = results.filter(
        (result) => result.status === "rejected" || result.value.status !== 201,
      );

      if (failed.length === 0) {
        console.log(`Auxiliary Saved successfully`);
        // window.location.reload();
        await saveReceiptAllocation(rpNo);
      } else {
        failed.forEach((result) => {
          if (result.status === "rejected") {
            console.error(
              "Error while Saving one or more Auxiliary",
              result.reason,
            );
          } else {
            console.error(
              "Error while Saving one or more Auxiliary",
              result.value.data,
            );
          }
        });
        const firstErrorMessage =
          failed[0].status === "rejected"
            ? failed[0].reason?.response?.data?.message
            : failed[0].value?.data?.message;
        alert(firstErrorMessage || "Some Auxiliary failed to save");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.message);
      setisloading(false);
      console.error(`Error while Saving Auxiliary`, error);
    }
  }

  async function saveReceiptAllocation(rpNo) {
    try {
      const results = await Promise.allSettled(
        selectedRows.map((row) =>
          axios.post(
            `${BASEURL_GLOBAL}/globalSpHandler?spname=1710`,
            {
              RECIEPTNO: Number(rpNo),
              RECIEPTINVNO: row.BILLNO,
              INVOICEAMOUNT: row.AMOUNT ? Number(row.AMOUNT) : 0,
              ALLOCATEDAMOUNT: row.ALLOCATEDAMOUNT
                ? Number(row.ALLOCATEDAMOUNT)
                : 0,
              RECEIPTMPESAAMOUNT: row.MPESA ? Number(row.MPESA) : 0,
              RECEIPTCREDITCARDAMOUNT: row.CREDITCARD
                ? Number(row.CREDITCARD)
                : 0,
              RECEIPTCASHAMOUNT: row.CASH ? Number(row.CASH) : 0,
              RECEIPTMPESAREFNUMBER: row.MPESAREFNO || "",
              RECEIPTCREDITCARDREFNUMBER: row.CREDITCARDREFNO || "",
            },
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessiontoken,
              },
            },
          ),
        ),
      );

      const failed = results.filter(
        (result) => result.status === "rejected" || result.value.status !== 201,
      );

      if (failed.length === 0) {
        console.log(`Receipt Allocation saved successfully`);
        await SaveReceiptsToFinance(rpNo);
      } else {
        failed.forEach((result) => {
          if (result.status === "rejected") {
            console.error(
              "Error while Saving Receipt Allocation",
              result.reason,
            );
          } else {
            console.error(
              "Error while Saving Receipt Allocation",
              result.value.data,
            );
          }
        });
        const firstErrorMessage =
          failed[0].status === "rejected"
            ? failed[0].reason?.response?.data?.message
            : failed[0].value?.data?.message;
        alert(firstErrorMessage || "Some Receipt Allocations failed to save");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.message);
      setisloading(false);
      console.error(`Error while Saving Receipt Allocated`, error);
    }
  }

  async function SaveReceiptsToFinance(rpNo) {
    try {
      setisloading(true);

      // 1. Get operational receipt number
      const receiptResponse = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1766`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      const operationalReceiptNo = receiptResponse.data?.[0]?.RECIEPTNO
        ? Number(receiptResponse.data[0].RECIEPTNO)
        : 0;

      // 2. Save receipt to finance
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1728`,
        {
          OPERATIONALRECEIPTNO: rpNo ? Number(rpNo) : 0,
          RECEIPTNO: operationalReceiptNo ? Number(operationalReceiptNo) : 0,
          PROCESSEDDATE: moment().format("YYYY/MM/DD HH:mm:ss"),
          PROCESSEDBY: userState?.emailId?.split("@")?.[0]?.toUpperCase() || "",
          DIVISION: division || "",
          NEWEXISTING: historicreceipts === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      // 3. Check response
      if (response.status === 201) {
        alert("Receipt Saved Successfully");

        setisloading(false);

        // 4. Ask whether to print
        const isPrint = window.confirm("Do you want to print this Receipt?");

        if (isPrint) {
          setPopUpReport(true);
          generateReport(rpNo);
        } else {
          window.location.reload();
        }
      } else {
        console.error("Error while saving receipt");
        alert("Receipt failed to save");
        setisloading(false);
      }
    } catch (error) {
      console.error("Error while saving receipt:", error);

      alert(
        error?.response?.data?.message ||
          "Something went wrong while saving the receipt",
      );

      setisloading(false);
    }
  }
  // Crystal Reports
  function generateReport(rpNo) {
    setPdfData(null);

    if (!rpNo) {
      alert("Please select a Receipt NO");
      return;
    }
    setLoadingScreenBlock(true);
    axios
      .post(
        `${BASEURL}/generateReports`,
        {
          REPORTNAME: "CrPOSReciept.rpt",
          DOCNO: Number(rpNo),
          // VALUE2: Number(newReceiptNo),
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
          responseType: "blob",
        },
      )
      .then(async (res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfData(fileURL);
        await SavePrintReceipt();
        setLoadingScreenBlock(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  }

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  async function CancelReceipt() {
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1746`,
        {
          RECIEPTNO: Number(newReceiptNo),
          CANCELREASON: selReason || "",
          CANCELLEDBY: userState.emailId.split("@")[0].toUpperCase() || "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert("Receipt Cancelled Succesfully");
        setisloading(false);
        window.location.reload();
      } else {
        console.error(`Error while Cancelling Receipt`);
        alert("Receipt failed to cancel");
        setisloading(false);
      }
    } catch (error) {
      console.log(error);
      setisloading(false);
      console.error(`Error while Cancelling Receipt`, error);
    }
  }

  // SAVE PRINT
  async function SavePrintReceipt() {
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1804`,
        {
          RECEIPTNO: Number(newReceiptNo),
          PRINTBY: userState.emailId.split("@")[0].toUpperCase() || "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        console.log("Receipt Print Saved Succesfully");
      } else {
        console.error(`Error while Saving Receipt Print`);
      }
    } catch (error) {
      console.log(error);
      console.error(`Error while  Saving Receipt Print`, error);
    }
  }

  //  ********************** NEW UPDATES **********************

  // useEffect(() => {
  //   if (listofpaymentmodes?.length) {
  //     setPaymentDetails(
  //       listofpaymentmodes.map((item) => ({
  //         payMode: item.PAYMODE,
  //         amount: "",
  //         refNo: "",
  //       })),
  //     );
  //   }

  //   axios
  //     .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1680`, {
  //       headers: {
  //         "auth-token": authToken,
  //         "session-token": sessiontoken,
  //       },
  //     })
  //     .then((response) => {
  //       setSalesBills(response.data);
  //       setOriginalBills(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching 1680", error);
  //     });
  // }, [listofpaymentmodes]);

  // Payment modes
  useEffect(() => {
    if (listofpaymentmodes?.length) {
      setPaymentDetails(
        listofpaymentmodes.map((item) => ({
          payMode: item.PAYMODE,
          amount: "",
          refNo: "",
        })),
      );
    }
  }, [listofpaymentmodes]);

  // Sales bills
  useEffect(() => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1680`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setSalesBills(response.data);
        setOriginalBills(response.data);
      })
      .catch((error) => {
        console.error("Error fetching 1680", error);
      });
  }, []);

  useEffect(() => {
    if (mergeBills === true) {
      setSalesBills(originalBills);
    } else {
      keepOnlySelectedBill(cashPoToPass);
    }
  }, [mergeBills]);

  // Updated Payment Mode Part
  const handlePaymentChange = (index, field, value) => {
    // Numeric only
    const numericValue = value.replace(/\D/g, "");

    setPaymentDetails((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, [field]: numericValue } : item,
      ),
    );
  };

  // const totalReceived = paymentDetails.reduce(
  //   (sum, item) => sum + (Number(item.amount) || 0),
  //   0,
  // );

  const filtSales = salesBills.filter((item) => {
    const searchData = searchSales.toLowerCase().split(" ").filter(Boolean);
    const itemDate = new Date(item.DATETIME);
    const start = salStartdate ? new Date(salStartdate) : null;
    const end = salEndDate ? new Date(salEndDate) : null;

    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);

    // if (searchData.length === 0 && !salStartdate && !salEndDate && !status) {
    if (searchData.length === 0 && !salStartdate && !salEndDate) {
      // if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      // return ["CLIENT NAME", "BILLNO", "MODEOFPAY", "PONOTES"].some(
      return ["BILLNO", "TABLENO", "DIVISION", "CURRENCY", "WAITER"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
      (!start || itemDate >= start) && (!end || itemDate <= end);

    return textMatch && dateMatch;
  });

  // const handleRowSelect = (row, checked) => {
  //   if (checked) {
  //     setSelectedRows((prev) => {
  //       const rows = [
  //         ...prev,
  //         {
  //           ...row,
  //             CASH: "",
  //         MPESA: "",
  //         MPESAREFNO: "",
  //         CREDITCARD: "",
  //         CREDITCARDREFNO: "",
  //         TOTALRECEIVED: 0,
  //         CHANGE: 0,
  //         ALLOCATEDAMOUNT: 0,
  //         },
  //       ];

  //       return distributeAmount(rows, totalReceived);
  //     });
  //   } else {
  //     setSelectedRows((prev) => {
  //       const rows = prev.filter((x) => x.BILLNO !== row.BILLNO);

  //       return distributeAmount(rows, totalReceived);
  //     });
  //   }
  // };

  // NEw Update - Merge table 1 To Table 2

  const handleRowSelect = (row, checked) => {
    if (checked) {
      setSelectedRows((prev) => [
        ...prev,
        {
          ...row,
          CASH: "",
          MPESA: "",
          MPESAREFNO: "",
          CREDITCARD: "",
          CREDITCARDREFNO: "",
          TOTALRECEIVED: 0,
          CHANGE: 0,
          ALLOCATEDAMOUNT: 0,
        },
      ]);
    } else {
      setSelectedRows((prev) => prev.filter((x) => x.BILLNO !== row.BILLNO));
    }
  };

  // Create the payment columns dynamically from the available payment modes
  const paymentModeColumns = useMemo(() => {
    if (!listofpaymentmodes?.length) return [];

    return listofpaymentmodes
      .filter((item) => item?.PAYMODE)
      .map((item) => {
        const payMode = String(item.PAYMODE).trim();
        const normalized = payMode.toUpperCase();

        // Convert PAYMODE into the property name used in selectedRows
        let amountKey = normalized.replace(/\s+/g, "");

        // Reference number is required for these payment modes
        const hasRefNo = ["MPESA", "CREDIT CARD"].includes(normalized);

        let refKey = null;

        if (normalized === "MPESA") {
          refKey = "MPESAREFNO";
        } else if (normalized === "CREDIT CARD") {
          refKey = "CREDITCARDREFNO";
        }

        return {
          payMode,
          normalized,
          amountKey,
          hasRefNo,
          refKey,
        };
      });
  }, [listofpaymentmodes]);

  // const getRowTotalReceived = (row) => {
  //   return (
  //     Number(row?.CASH || 0) +
  //     Number(row?.MPESA || 0) +
  //     Number(row?.CREDITCARD || 0)
  //   );
  // };

  const getRowTotalReceived = (row) => {
    if (!row) return 0;

    return paymentModeColumns.reduce((total, payment) => {
      return total + Number(row?.[payment.amountKey] || 0);
    }, 0);
  };

  const totalReceived = selectedRows.reduce(
    (sum, row) => sum + getRowTotalReceived(row),
    0,
  );

  const handleRowPaymentChange = (billNo, field, value) => {
    // Allow only numbers for payment amount fields
    if (
      ["CASH", "MPESA", "CREDITCARD"].includes(field) &&
      value !== "" &&
      !/^\d*\.?\d*$/.test(value)
    ) {
      return;
    }

    setSelectedRows((prev) => {
      return prev.map((row) => {
        if (row.BILLNO !== billNo) return row;

        const updatedRow = {
          ...row,
          [field]: value,
        };

        const totalReceived = getRowTotalReceived(updatedRow);
        const pending = Number(updatedRow.PENDING || 0);

        updatedRow.TOTALRECEIVED = totalReceived;

        // Change
        updatedRow.CHANGE =
          totalReceived > pending ? totalReceived - pending : 0;

        // Allocation
        updatedRow.ALLOCATEDAMOUNT = Math.min(totalReceived, pending);

        return updatedRow;
      });
    });
  };

  useEffect(() => {
    const totalPending = selectedRows.reduce(
      (sum, item) => sum + (Number(item.PENDING) || 0),
      0,
    );

    setTotalBill(totalPending);

    const received = selectedRows.reduce(
      (sum, item) => sum + getRowTotalReceived(item),
      0,
    );

    setTotalReceiveAmt(Math.min(received, totalPending));

    setchangegiven(received > totalPending ? received - totalPending : 0);
  }, [selectedRows]);

  // const handleSelectAll = (checked) => {
  //   if (!checked) {
  //     setSelectedRows([]);
  //     return;
  //   }

  //   const rows = filtSales.map((item) => ({
  //     ...item,
  //     ALLOCATEDAMOUNT: 0,
  //   }));

  //   setSelectedRows(distributeAmount(rows, totalReceived));
  // };

  const handleSelectAll = (checked) => {
    if (!checked) {
      setSelectedRows([]);
      return;
    }

    const rows = filtSales.map((item) => ({
      ...item,
      CASH: "",
      MPESA: "",
      MPESAREFNO: "",
      CREDITCARD: "",
      CREDITCARDREFNO: "",
      TOTALRECEIVED: 0,
      CHANGE: 0,
      ALLOCATEDAMOUNT: 0,
    }));

    setSelectedRows(rows);
  };

  const previousReceived = useRef(0);

  useEffect(() => {
    const diff = Number(totalReceived) - Number(previousReceived.current);

    if (!selectedRows.length || diff === 0) {
      previousReceived.current = Number(totalReceived);
      return;
    }

    setSelectedRows((prev) => {
      let rows = [...prev];

      if (diff > 0) {
        // Grow allocations
        let remaining = diff;

        while (remaining > 0) {
          const available = rows.filter((r) => r.ALLOCATEDAMOUNT < r.PENDING);

          if (!available.length) break;

          const share = remaining / available.length;

          let changed = false;

          available.forEach((row) => {
            const room = row.PENDING - row.ALLOCATEDAMOUNT;
            const add = Math.min(room, share);

            row.ALLOCATEDAMOUNT += add;
            remaining -= add;

            if (add > 0) changed = true;
          });

          if (!changed) break;
        }

        return [...rows];
      }
      // diff < 0

      let reduce = Math.abs(diff);

      // Clone rows
      rows = rows.map((r) => ({ ...r }));

      while (reduce > 0) {
        // Step 1: Prefer rows which are NOT fully allocated
        let candidates = rows.filter(
          (r) => r.ALLOCATEDAMOUNT > 0 && r.ALLOCATEDAMOUNT < Number(r.PENDING),
        );

        // Step 2: If every row is fully allocated then unlock all rows
        if (!candidates.length) {
          candidates = rows.filter((r) => r.ALLOCATEDAMOUNT > 0);
        }

        if (!candidates.length) break;

        const share = reduce / candidates.length;

        let deducted = 0;

        candidates.forEach((row) => {
          const deduction = Math.min(share, row.ALLOCATEDAMOUNT);

          row.ALLOCATEDAMOUNT -= deduction;

          deducted += deduction;
        });

        deducted = Number(deducted.toFixed(2));

        if (deducted <= 0) break;

        reduce -= deducted;

        reduce = Number(reduce.toFixed(2));
      }

      return rows;
    });

    previousReceived.current = Number(totalReceived);
  }, [totalReceived]);

  const handleAllocatedChange = (billNo, value) => {
    const amount = Number(value || 0);

    setSelectedRows((prev) => {
      const currentRow = prev.find((x) => x.BILLNO === billNo);

      if (!currentRow) return prev;

      // Cannot exceed pending
      if (amount > Number(currentRow.PENDING)) {
        alert("Allocated Amount cannot exceed Pending Amount");
        return prev;
      }

      const total = prev.reduce((sum, item) => {
        if (item.BILLNO === billNo) return sum + amount;
        return sum + Number(item.ALLOCATEDAMOUNT || 0);
      }, 0);

      if (total > Number(totalReceived || 0)) {
        alert("Total Allocated Amount cannot exceed Total Received");
        return prev;
      }

      return prev.map((item) =>
        item.BILLNO === billNo
          ? {
              ...item,
              ALLOCATEDAMOUNT: amount,
            }
          : item,
      );
    });
  };

  // const distributeAmount = (rows, totalReceived) => {
  //   let remaining = Number(totalReceived || 0);

  //   const updatedRows = rows.map((r) => ({
  //     ...r,
  //     ALLOCATEDAMOUNT: 0,
  //   }));

  //   // rows still eligible for receiving amount
  //   let remainingRows = updatedRows.map((_, i) => i);

  //   while (remainingRows.length > 0 && remaining > 0) {
  //     const split = remaining / remainingRows.length;

  //     let anyRowCompleted = false;

  //     remainingRows = remainingRows.filter((index) => {
  //       const row = updatedRows[index];
  //       const pending = Number(row.PENDING);

  //       if (pending <= split) {
  //         row.ALLOCATEDAMOUNT = pending;
  //         remaining -= pending;
  //         anyRowCompleted = true;
  //         return false;
  //       }

  //       return true;
  //     });

  //     if (!anyRowCompleted) {
  //       remainingRows.forEach((index) => {
  //         updatedRows[index].ALLOCATEDAMOUNT += split;
  //       });

  //       remaining = 0;
  //       break;
  //     }
  //   }

  //   return updatedRows;
  // };

  const distributeAmount = (rows) => {
    return rows.map((row) => {
      const totalReceived = getRowTotalReceived(row);
      const pending = Number(row.PENDING || 0);

      return {
        ...row,
        TOTALRECEIVED: totalReceived,
        CHANGE: totalReceived > pending ? totalReceived - pending : 0,
        ALLOCATEDAMOUNT: Math.min(totalReceived, pending),
      };
    });
  };

  useEffect(() => {
    let total = 0;

    if (selectedRows?.length > 0) {
      selectedRows.forEach((item) => {
        total += parseFloat(item?.PENDING) || 0;
      });

      setTotalBill(total);
      if (totalReceived > total) {
        setTotalReceiveAmt(total);
      } else {
        setTotalReceiveAmt(totalReceived);
      }
    }
  }, [selectedRows]);

  useEffect(() => {
    if (totalBill && totalReceived && totalReceived > totalBill) {
      setchangegiven(totalReceived - totalBill);
    } else {
      setchangegiven("");
    }
  }, [totalBill, totalReceived]);

  useEffect(() => {
    setSelectPaymentList(paymentDetails?.filter((item) => item.amount !== ""));
  }, [paymentDetails]);

  // ************ FROM RECEIVE MONEY PAGE ************
  useEffect(() => {
    if (cashPoToPass && salesBills?.length > 0 && mergeBills === false) {
      handleRowSelectByBillNo(cashPoToPass);
      keepOnlySelectedBill(cashPoToPass);
    }
  }, [cashPoToPass, salesBills, mergeBills]);

  const handleRowSelectByBillNo = (billNo) => {
    const row = salesBills.find((item) => item.BILLNO === billNo);

    if (!row) return;

    setSelectedRows((prev) => {
      // Prevent duplicates
      if (prev.some((item) => item.BILLNO === billNo)) {
        return prev;
      }

      return [
        ...prev,
        {
          ...row,
          ALLOCATEDAMOUNT: 0,
        },
      ];
    });
  };

  const keepOnlySelectedBill = (billNo) => {
    setSalesBills((prev) => prev.filter((item) => item.BILLNO === billNo));
  };

  const previousPaymentDetails = useRef(null);

  useEffect(() => {
    if (recoverFromWaiter && paymentDetails.length > 0) {
      // Save the normal state only when entering recover mode
      if (previousPaymentDetails.current === null) {
        previousPaymentDetails.current = paymentDetails;
      }

      // In recover mode, ONLY use totalBill
      setPaymentDetails((prev) =>
        prev.map((item, index) =>
          index === 0
            ? {
                ...item,
                amount: String(totalBill || ""),
              }
            : {
                ...item,
                amount: "",
                refNo: "",
              },
        ),
      );
    } else if (!recoverFromWaiter && previousPaymentDetails.current !== null) {
      // Restore normal state
      setPaymentDetails(previousPaymentDetails.current);

      previousPaymentDetails.current = null;
    }
  }, [recoverFromWaiter, totalBill]);

  const visiblePaymentDetails = recoverFromWaiter
    ? paymentDetails.slice(0, 1)
    : paymentDetails;

  return (
    <>
      {!hideNavBar && <DashBoardNavbar />}
      {!hideNavBar && <HomePageNavbarFinancials />}
      {isloading ? (
        <Loading />
      ) : (
        <div className={`h-auto w-full ${hideNavBar ? "mt-10" : "mt-4"}`}>
          {/* 1st row */}

          <div className="w-full  bg-[#002e62db] flex flex-row px-3 py-1 my-2 justify-between">
            <p className="text-white ml-2 lg:mr-14">Mars Track Point of Sale</p>
          </div>

          {/* Status Line  */}
          {historicreceipts === true && (
            <div className="flex flex-wrap ml-2 gap-1 mb-2">
              <p className="font-bold">Created By:</p>
              <span className="text-red-500">{createdBy}</span>
              <p className="font-bold">|</p>
              <p className="font-bold">Created Date:</p>
              <span className="text-red-500">
                {createdDate ? moment(createdDate).format("DD/MM/YYYY") : ""}
              </span>
              <p className="font-bold">|</p>
              <p className="font-bold">Cancellation Status:</p>
              <span className="text-red-500">
                {cancelled === true ? "CANCELLED" : "NOT CANCELLED"}
              </span>
              <p className="font-bold">|</p>
              {cancelled === true && (
                <>
                  <p className="font-bold">Cancelled By:</p>
                  <span className="text-red-500">{cancelledBy}</span>
                  <p className="font-bold">|</p>
                  <p className="font-bold">Cancelled Date:</p>
                  <span className="text-red-500">
                    {cancelledDate
                      ? moment(cancelledDate).format("DD/MM/YYYY")
                      : ""}
                  </span>
                </>
              )}
            </div>
          )}

          <div className="flex flex-wrap items-center gap-y-2 mt-2 ml-2">
            <button
              className="h-8  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleButtonClick("first");
              }}
            >
              {"<<"}
            </button>
            <button
              className="h-8  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleButtonClick("decrement");
              }}
            >
              {"<"}
            </button>
            <button
              className="h-8  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleButtonClick("increment");
              }}
            >
              {">"}
            </button>
            <button
              className="h-8  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleButtonClick("latest");
              }}
            >
              {">>"}
            </button>

            <button
              className="flex h-8 items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setSelectedRows([]);
                setShowTable(true);
                sethistoricreceipts(false);
                setPdfData(null);
                setHistTableData([]);
                setTotalBill("");
                setTotalReceiveAmt("");
                setFinancialReceiptNo("");
                setchangegiven("");
                sethvat("");
                sethlevy("");
                setMergeBills(false);
                setRecoverFromWaiter(false);
                setPaymentDetails(
                  listofpaymentmodes.map((item) => ({
                    payMode: item.PAYMODE,
                    amount: "",
                    refNo: "",
                  })),
                );

                axios
                  .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=636`, {
                    headers: {
                      "auth-token": authToken,
                      "session-token": sessiontoken,
                    },
                  })
                  .then((response) => {
                    setnewReceiptNo(response.data[0].RECIEPTNO);
                    setLatestReceiptNo(response.data[0].RECIEPTNO);
                  })
                  .catch((error) => {
                    console.error("Error fetching New Cash POS Number:", error);
                  });
              }}
            >
              NEW
            </button>
            <button
              className="h-8 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                // if (historicreceipts) {
                //   alert("Cannot Save Hsitoric Receipts");
                // } else {
                if (!newReceiptNo) {
                  alert("Kindly Provide Receipt No");
                } else if (selectedRows?.length === 0) {
                  alert("Kindly Select the Orders from table");
                }
                // else if (selectPaymentList?.length === 0) {
                //   alert("Kindly enter the amount within respective PayModes");
                // }
                else {
                  await SaveReceipts();
                  // alert("Receipt Saved Succesfully");
                  // window.location.reload();
                }
                // }
              }}
            >
              Save
            </button>
            <button
              className="h-8 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                if (historicreceipts === false) {
                  alert("Kindly Save the Receipt first");
                } else {
                  setisloading(true);
                  axios
                    .get(
                      `${BASEURL_GLOBAL}/globalViewHandler?viewname=1758&BANK_REC_VOUCHER_CODE=RECIEPT&BANK_REC_DOC_NO=${financialReceiptNo}`,
                      {
                        headers: {
                          "auth-token": authToken,
                          "session-token": sessiontoken,
                        },
                      },
                    )
                    .then((res) => {
                      setisloading(false);
                      if (res?.data?.length > 0) {
                        alert("This Receipt has been reconciled");
                        return;
                      } else {
                        const isCancel = window.confirm(
                          "This action is not reversable, are you sure you want to proceed?",
                        );
                        if (isCancel === true) {
                          setShowCancel(true);
                        } else {
                          setShowCancel(false);
                        }
                      }
                    })
                    .catch((err) => {
                      setisloading(false);
                      console.log("Error While fetching 1758", err);
                    });
                }
              }}
            >
              Cancel
            </button>

            {showCancel && (
              <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black h-[300px] w-[95%] sm:w-[80%] lg:w-[500px] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
                <div className="flex gap-2 mt-5">
                  <p className="text-red-600">Cancellation Reason :</p>
                  <Select
                    styles={customStyless}
                    onChange={(e) => {
                      setSelReason(e.value);
                    }}
                    value={
                      selReason
                        ? { label: selReason, value: selReason }
                        : { label: "", value: "" }
                    }
                    options={[
                      { value: "", label: "" },
                      ...cancelReasonList?.map((item) => ({
                        label: item.REASON,
                        value: item.REASON,
                      })),
                    ]}
                  />
                </div>

                <div className="flex justify-center mt-20">
                  <button
                    className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => {
                      if (selReason) {
                        CancelReceipt();
                      } else {
                        alert("Kindly Supply Cancellation Reason");
                      }
                    }}
                  >
                    CANCEL
                  </button>
                </div>

                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowCancel(false)}
                >
                  Close
                </button>
              </div>
            )}

            <button
              className="h-8 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                if (historicreceipts === false) {
                  alert("Kindly Save the Receipt first");
                } else {
                  axios
                    .get(
                      `${BASEURL_GLOBAL}/globalViewHandler?viewname=649&RECEIPTNO=${newReceiptNo}`,
                      {
                        headers: {
                          "auth-token": authToken,
                          "session-token": sessiontoken,
                        },
                      },
                    )
                    .then((response) => {
                      if (
                        response.data[0].PRINTED === true &&
                        response.data[0].PRINTEDCOUNTER > 1
                      ) {
                        const isPrint = window.confirm(
                          "This document is already printed, do you still want to print?",
                        );
                        if (isPrint) {
                          setPopUpReport(true);
                          generateReport(newReceiptNo);
                        }
                      } else {
                        setPopUpReport(true);
                        generateReport(newReceiptNo);
                      }
                    })
                    .catch((error) => {
                      console.error("Error fetching List Of Receipts:", error);
                    });
                }
              }}
            >
              Print
            </button>
            <p className="text-red-600 lg:ml-2">Division:</p>
            {/* <p className="ml-2 lg:ml-20">
                {division ? division : divisionState}
              </p> */}
            <select
              onChange={(e) => {
                setdivsion(e.target.value);
                dispatch(setDivision(e.target.value));
              }}
              className="w-full sm:w-44 h-8 border-black border ml-2 rounded"
            >
              <option>{divisionState}</option>
              {userdivisionRights.map((item) =>
                item.OM_USER_DIVISION !== divisionState ? (
                  <option
                    key={item.OM_USER_DIVISION}
                    value={item.OM_USER_DIVISION}
                  >
                    {item.OM_USER_DIVISION}
                  </option>
                ) : null,
              )}
            </select>
          </div>

          <div className="flex flex-wrap items-center gap-1 lg:mt-2">
            <p className="text-red-600 lg:ml-1">Receipt No:</p>
            <input
              className="w-14 h-8 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={newReceiptNo}
              readOnly
            ></input>
            <button
              className="flex items-center h-8 justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-1 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setcashsalepopup(true);
              }}
            >
              ...
            </button>
            {cashsalepopup && (
              <div className="fixed top-[100px] left-1/2 -translate-x-1/2 bg-white border border-black h-[500px] w-[95%] sm:w-[80%] lg:w-[900px] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
                <section className="lg:flex">
                  <div className="flex flex-wrap items-center mt-2 gap-2">
                    <p className="text-red-600">Search:</p>
                    <input
                      className="w-full sm:w-64 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                      type="text"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    ></input>
                    <p className="text-red-600">Start Date:</p>
                    <input
                      type="date"
                      className="w-full sm:w-32 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                      onChange={(e) => {
                        setstartdate(e.target.value);
                      }}
                      value={startdate.split("T")[0]}
                    ></input>
                    <p className="text-red-600">End Date:</p>
                    <input
                      type="date"
                      className="w-full sm:w-32 h-8 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                      onChange={(e) => {
                        setEnddate(e.target.value);
                      }}
                      value={enddate.split("T")[0]}
                    ></input>
                    <button
                      className="flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300 mx-2"
                      onClick={() => setcashsalepopup(false)}
                    >
                      Close
                    </button>
                  </div>
                </section>
                <aside className="table__pos__app w-full overflow-x-auto">
                  <table class="custom-table ">
                    <thead class="header-cell">
                      <tr>
                        <td>Division</td>
                        <td>Receipt No</td>
                        <td>Receipt Date</td>
                        <td>Amount</td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtHistoric.map((row, index) => (
                        <tr
                          key={index}
                          onClick={() => {
                            setcashsalepopup(false);
                            handleReceipts(row);
                          }}
                          className={
                            index < receiptdata.length
                              ? "border-b cursor-pointer text-sm table-row"
                              : ""
                          }
                        >
                          <td>{row.DIVISION ? row.DIVISION : ""}</td>
                          <td className="text-right pr-8">
                            {row.RECEIPTNO ? row.RECEIPTNO : ""}
                          </td>
                          <td>
                            {row.RECEIPTDATE
                              ? moment(row.RECEIPTDATE.split("T")[0]).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </td>
                          <td className="text-right">
                            {row.RECEIPTAMOUNT
                              ? row.RECEIPTAMOUNT.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : ""}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </aside>
              </div>
            )}

            <p className="text-red-600 lg:ml-1">User ID:</p>
            <input
              className="w-32 h-8 border border-black ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={email?.split("@")?.[0]}
              disabled={historicreceipts == true}
            ></input>
            <p className="text-red-600 ml-1">Date & Time:</p>
            <input
              className="w-full sm:w-44 h-8 lg:ml-1 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={
                historicreceipts === true
                  ? moment.utc(date)?.format("DD/MM/YYYY HH:mm:ss")
                  : moment(date)?.format("DD/MM/YYYY HH:mm:ss")
              }
              disabled={historicreceipts == true}
              readOnly
            ></input>
          </div>
          <div className="flex flex-wrap items-center gap-2 lg:mt-2 mr-0 lg:mr-20">
            <input
              className="w-4 h-4 mt-1"
              type="checkbox"
              value={recoverFromWaiter}
              onChange={(e) => setRecoverFromWaiter(!recoverFromWaiter)}
            ></input>
            <p className="text-red-600 lg:ml-2">Recover From Waiter</p>
            {recoverFromWaiter === true && (
              <>
                <p className="text-red-600 lg:ml-5">Waiter Email :</p>
                <Select
                  styles={customStyless}
                  onChange={(e) => {
                    setSelWaiterEmail(e.value);
                  }}
                  value={
                    selWaiterEmail
                      ? { label: selWaiterEmail, value: selWaiterEmail }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...waiterList?.map((item) => ({
                      label: item.USEREMAIL,
                      value: item.USEREMAIL,
                    })),
                  ]}
                />
              </>
            )}
            <input
              className="w-4 h-4 mt-1 ml-4"
              type="checkbox"
              value={mergeBills}
              onChange={(e) => setMergeBills(!mergeBills)}
            ></input>
            <p className="text-red-600 lg:ml-2">Merge Bills</p>

            {recoverFromWaiter === true && (
              <>
                <p className="text-red-600 lg:ml-4">Narration </p>
                <textarea
                  rows={2}
                  className="lg:ml-2 w-full sm:w-64 resize-none"
                  value={narrationForRecover}
                  onChange={(e) => setNarrationForRecover(e.target.value)}
                ></textarea>
              </>
            )}
          </div>

          {/* Table */}
          {histTableData?.length > 0 ? (
            <aside className="w-full table__pos__app text-sm overflow-x-auto">
              <table class="custom-table">
                <thead class="header-cell">
                  <tr>
                    <td className="text-left">S no</td>
                    <td className="pl-2">ORDER NO</td>
                    <td className="text-left">TABLE NO</td>
                    <td className="text-left">WAITER</td>
                    <td className="text-left">ORDER TIME</td>
                    <td className="text-right">AMOUNT</td>
                    <td className="text-right">CASH</td>
                    <td className="text-right">MPESA</td>
                    <td className="text-right">REFNO</td>
                    <td className="text-right">CREDIT CARD</td>
                    <td className="text-right">REF NO</td>
                    <td className="text-right">TOTAL RECEIVED</td>
                    <td className="text-right">CHANGE</td>
                    <td className="text-right">ALLOC AMOUNT</td>
                    <td className="text-right">CURRENCY</td>
                  </tr>
                </thead>
                <tbody>
                  {histTableData?.map((row, index) => (
                    <tr
                      key={row?.ORDERNO}
                      className="border-b cursor-pointer text-[10px] table-row"
                    >
                      {/* S NO */}
                      <td className="text-right">{index + 1}</td>

                      {/* ORDER NO */}
                      <td className="text-right pr-12">{row?.ORDERNO || ""}</td>

                      {/* TABLE NO */}
                      <td className="text-left">{row?.TABLENO || ""}</td>

                      {/* WAITER */}
                      <td className="text-left">{row?.WAITER || ""}</td>

                      {/* ORDER TIME */}
                      <td className="text-left">
                        {row?.ORDERTIME
                          ? moment?.utc(row.ORDERTIME).format("hh:mm:ss")
                          : ""}
                      </td>

                      {/* AMOUNT */}
                      <td className="text-right pr-12">
                        {Number(row?.AMOUNT || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right pr-12">
                        {Number(row?.CASHAMOUNT || 0).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="text-right pr-12">
                        {Number(row?.MPESAMOUNT || 0).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="text-left">{row?.MPESAREF || ""}</td>
                      <td className="text-right pr-12">
                        {Number(row?.CREDITCARDAMOUNT || 0).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="text-left">{row?.CREDITCARDREF || ""}</td>
                      <td className="text-right pr-12">
                        {Number(row?.TOTALRECEIVED || 0).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>
                      <td className="text-right pr-12">
                        {Number(row?.CHANGE || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right pr-12">
                        {Number(row?.ALLOCAMOUNT || 0).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </td>

                      {/* CURRENCY */}
                      <td className="text-left">{row?.CURRENCY || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </aside>
          ) : (
            <aside className="w-full table__pos__app text-sm overflow-x-auto">
              <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                <p>Search:</p>
                <input
                  className="w-full sm:w-[300px] h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={searchSales}
                  onChange={(e) => {
                    setSearchSales(e.target.value);
                  }}
                />

                <p className="text-red-600 ml-2">Start Date:</p>
                <input
                  type="date"
                  className="w-full sm:w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setSalStartDate(e.target.value);
                  }}
                  value={salStartdate.split("T")[0]}
                ></input>
                <p className="text-red-600 ml-2">End Date:</p>
                <input
                  type="date"
                  className="w-full sm:w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setSalEndDate(e.target.value);
                  }}
                  value={salEndDate.split("T")[0]}
                ></input>
              </div>
              <table className="custom-table text-[10px]">
                <thead className="header-cell">
                  <tr>
                    {/* S NO */}
                    <td className="text-left">S no</td>

                    {/* SELECT ALL */}
                    <td className="text-center">
                      <input
                        type="checkbox"
                        checked={
                          filtSales.length > 0 &&
                          selectedRows.length === filtSales.length
                        }
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    </td>

                    {/* ORDER NO */}
                    <td className="pl-2">ORDER NO</td>

                    {/* TABLE NO */}
                    <td className="text-left">TABLE NO</td>

                    {/* WAITER */}
                    <td className="text-left">WAITER</td>

                    {/* ORDER TIME */}
                    <td className="text-left">ORDER TIME</td>

                    {/* AMOUNT */}
                    <td className="text-right">AMOUNT</td>

                    {/* =====================================================
                      DYNAMIC PAYMENT HEADERS
                      ===================================================== */}
                    {paymentModeColumns.map((payment) => (
                      <Fragment key={payment.normalized}>
                        <td className="text-right">{payment.payMode}</td>

                        {payment.hasRefNo && (
                          <td className="text-right">REF NO</td>
                        )}
                      </Fragment>
                    ))}

                    {/* TOTAL RECEIVED */}
                    <td className="text-right">TOTAL RECEIVED</td>

                    {/* CHANGE */}
                    <td className="text-right">CHANGE</td>

                    {/* ALLOC AMOUNT */}
                    <td className="text-right">ALLOC AMOUNT</td>

                    {/* PENDING */}
                    <td className="text-right">PENDING</td>

                    {/* CURRENCY */}
                    <td className="text-right">CURRENCY</td>
                  </tr>
                </thead>

                <tbody>
                  {filtSales.map((row, index) => {
                    const selectedRow = selectedRows.find(
                      (x) => x.BILLNO === row.BILLNO,
                    );

                    const totalReceived = selectedRow
                      ? getRowTotalReceived(selectedRow)
                      : 0;

                    const pending = Number(row.PENDING || 0);

                    const change =
                      totalReceived > pending ? totalReceived - pending : 0;

                    const allocatedAmount = Math.min(totalReceived, pending);

                    return (
                      <tr
                        key={row?.BILLNO}
                        className="border-b cursor-pointer text-[10px] table-row"
                      >
                        {/* =====================================================
                          S NO
                          ===================================================== */}
                        <td className="text-right">{index + 1}</td>

                        {/* =====================================================
                          SELECT
                          ===================================================== */}
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.some(
                              (item) => item.BILLNO === row.BILLNO,
                            )}
                            onChange={(e) =>
                              handleRowSelect(row, e.target.checked)
                            }
                          />
                        </td>

                        {/* =====================================================
                          ORDER NO
                          ===================================================== */}
                        <td className="text-right pr-12">
                          {row?.BILLNO || ""}
                        </td>

                        {/* =====================================================
                          TABLE NO
                          ===================================================== */}
                        <td className="text-left">{row?.TABLENO || ""}</td>

                        {/* =====================================================
                          WAITER
                          ===================================================== */}
                        <td className="text-left">{row?.WAITER || ""}</td>

                        {/* =====================================================
                          ORDER TIME
                          ===================================================== */}
                        <td className="text-left">
                          {row?.DATETIME
                            ? moment(row.DATETIME).format("DD/MM/YYYY HH:mm:ss")
                            : ""}
                        </td>

                        {/* =====================================================
                          AMOUNT
                          ===================================================== */}
                        <td className="text-right pr-12">
                          {Number(row?.AMOUNT || 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        {/* =====================================================
                          DYNAMIC PAYMENT COLUMNS
                          ===================================================== */}
                        {paymentModeColumns.map((payment) => (
                          <Fragment key={`${row.BILLNO}-${payment.normalized}`}>
                            <td className="text-right">
                              <input
                                type="text"
                                inputMode="decimal"
                                className="border rounded w-16 text-right px-1"
                                value={selectedRow?.[payment.amountKey] ?? ""}
                                onChange={(e) =>
                                  handleRowPaymentChange(
                                    row.BILLNO,
                                    payment.amountKey,
                                    e.target.value,
                                  )
                                }
                                disabled={!selectedRow || historicreceipts}
                              />
                            </td>

                            {payment.hasRefNo && (
                              <td className="text-right">
                                <input
                                  type="text"
                                  className="border rounded w-20 text-right px-1"
                                  value={selectedRow?.[payment.refKey] ?? ""}
                                  onChange={(e) =>
                                    handleRowPaymentChange(
                                      row.BILLNO,
                                      payment.refKey,
                                      e.target.value,
                                    )
                                  }
                                  disabled={!selectedRow || historicreceipts}
                                />
                              </td>
                            )}
                          </Fragment>
                        ))}

                        {/* =====================================================
                          TOTAL RECEIVED
                          ===================================================== */}
                        <td className="text-right pr-6">
                          {totalReceived.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        {/* =====================================================
                          CHANGE
                          ===================================================== */}
                        <td className="text-right pr-6">
                          {change.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        {/* =====================================================
                          ALLOC AMOUNT
                          ===================================================== */}
                        <td className="text-right pr-6">
                          {allocatedAmount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        {/* =====================================================
                          PENDING
                          ===================================================== */}
                        <td className="text-right pr-12">
                          {pending.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        {/* =====================================================
                          CURRENCY
                          ===================================================== */}
                        <td className="text-left">{row?.CURRENCY || ""}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </aside>
          )}
        </div>
      )}
      {/* Report Generation */}

      {PopUpReport && (
        <div>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 99,
            }}
          />

          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              border: "1px solid black",
              height: "80%",
              width: "90%",
              maxWidth: "90%",
              maxHeight: "600px",
              padding: "16px",
              zIndex: 100,
              overflowY: "auto",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            {LoadingScreenBlock && <LoadingSpinner />}
            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setPopUpReport(false)}
            >
              Close
            </button>

            <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
              <div>
                <section className="lg:hidden block">
                  {pdfData && (
                    <button
                      className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                      onClick={handleDownload}
                    >
                      Download PDF
                    </button>
                  )}
                </section>

                <section className="hidden lg:block">
                  {pdfData ? (
                    <div className="w-full justify-center items-center min-h-screen p-4">
                      <section className="lg:flex lg:flex-col bg-white p-4 ga  shadow-lg rounded-md w-full min-h-[500px]">
                        <div>
                          {/* <div className="flex items-center gap-4"></div> */}

                          <section className="lg:hidden block">
                            {pdfData && (
                              <button
                                className="bg-blue-900 text-white  h-7 text-lg rounded-md px-3 ml-2 mr-2 focus:outline-none focus:ring"
                                onClick={handleDownload}
                              >
                                Download PDF
                              </button>
                            )}
                          </section>

                          <section className="hidden lg:block">
                            {pdfData ? (
                              <div className="mt-4">
                                <h2 className="text-lg font-bold">
                                  Generated Report
                                </h2>
                                <iframe
                                  src={pdfData}
                                  title="Generated Report"
                                  width="100%"
                                  height="600px"
                                ></iframe>
                              </div>
                            ) : (
                              <p className="text-2xl font-bold my-4 text-center">
                                No report available.
                              </p>
                            )}
                          </section>
                        </div>
                      </section>
                    </div>
                  ) : (
                    ""
                  )}
                </section>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default Receipt;
